import React from 'react';
import CheckoutPage from '@/components/monetization/CheckoutPage';

export default function Checkout() {
  return <CheckoutPage />;
}
